// VoiceAssistant.js - Asistente de voz con selección de idioma
import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import './VoiceAssistant.css';
import LanguageSwitch from './voice-assistant/LanguageSwitch';
import TranscribeBar from './voice-assistant/TranscribeBar';
import ChatBubble from './voice-assistant/ChatBubble';





const VoiceAssistant = () => {
  const [transcript, setTranscript] = useState('');
  const [responseText, setResponseText] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [useTranscribe, setUseTranscribe] = useState(true);
  const [micVolume, setMicVolume] = useState(0);
  const [assistantSpeaking, setAssistantSpeaking] = useState(false);
  const [inputLang, setInputLang] = useState('en-US');
  const [outputLang, setOutputLang] = useState('en-US');
  const [chatHistory, setChatHistory] = useState([]);  //chat history
  const recognitionRef = useRef(null);
  const wsRef = useRef(null);
  const audioContextRef = useRef(null);
  const mediaStreamRef = useRef(null);
  const processorRef = useRef(null);
  const silenceStartRef = useRef(null);
  const threadIdRef = useRef(null);
  const currentAudioRef = useRef(null);
  const silenceTimeout = 3000;
  const SILENCE_THRESHOLD = 0.005; //sensibilidad  de lo que es silencio
  const silentFrameCountRef = useRef(0);
  const frameSkipCountRef = useRef(0); // Para ignorar los primeros frames de ruido
  const hasDetectedSpeechRef = useRef(false); // Nuevo: saber si ya habló
  const inputLangRef = useRef(inputLang); //para el lenguaje asociado a transcibe y os switchs
  const outputLangRef = useRef(outputLang);  //para polly speakText








  useEffect(() => {
    const savedThreadId = localStorage.getItem('thread_id');
    if (savedThreadId) {
      threadIdRef.current = savedThreadId;
    }
  }, []);

  useEffect(() => {
  const container = document.getElementById('chat-history'); //Chat history
  if (container) container.scrollTop = container.scrollHeight;
  }, [chatHistory]);

  useEffect(() => {
  inputLangRef.current = inputLang; // para actualizar los lenguajes
  }, [inputLang]);

  useEffect(() => {
  outputLangRef.current = outputLang; //para polly speakText
}, [outputLang]);



  const stopAudioCapture = async () => {
    try {
      processorRef.current?.disconnect();
      mediaStreamRef.current?.getTracks().forEach((t) => t.stop());

      if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
        await audioContextRef.current.close();
      }
    } catch (err) {
      console.warn("⚠️ Error al cerrar audio:", err);
    } finally {
      processorRef.current = null;
      audioContextRef.current = null;
      mediaStreamRef.current = null;
      silenceStartRef.current = null;
      setIsListening(false);
    }
  };

  const handleListen = () => {
    if (isListening || isLoading || assistantSpeaking) return;

    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current = null;
    }

    if (wsRef.current && wsRef.current.readyState !== WebSocket.CLOSED) {
      console.warn("⏳ WebSocket aún activo, espera...");
      return;
    }

    useTranscribe ? startTranscribeStream() : startSpeechRecognition();
  };

  const interruptAssistant = () => {
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current = null;
      setAssistantSpeaking(false);
      console.log("🛑 Audio interrumpido por el usuario.");
      handleListen();
    }
  };

  const startSpeechRecognition = () => {
    if (!recognitionRef.current && 'webkitSpeechRecognition' in window) {
      recognitionRef.current = new window.webkitSpeechRecognition();
      recognitionRef.current.lang = inputLang;
      recognitionRef.current.interimResults = false;
      recognitionRef.current.continuous = false;
    }

    const recognition = recognitionRef.current;

    if (!recognition) {
      alert("Tu navegador no soporta reconocimiento de voz");
      return;
    }
    setIsListening(true);
    recognition.start();
    recognition.onresult = async (event) => {
      const finalText = event.results[0][0].transcript;
      setTranscript(finalText);
      setIsListening(false);
      recognition.stop();
      await sendToAssistant(finalText);
    };
    recognition.onerror = (event) => {
      console.error('🎤 Error de voz:', event.error);
      setIsListening(false);
    };
  };

  const fetchThreadId = async () => {
    try {
      const res = await axios.post('https://profevoz.asistentevirutalia.com/api/threads');
      const newThreadId = res.data.thread_id;
      localStorage.setItem('thread_id', newThreadId);
      threadIdRef.current = newThreadId;
      return newThreadId;
    } catch (err) {
      console.error('❌ Error obteniendo thread_id:', err);
      return null;
    }
  };

const speakText = async (text) => {
  if (assistantSpeaking) {
    console.warn("⏳ Ya se está reproduciendo audio, ignorando nueva llamada.");
    return;
  }

  try {
    setAssistantSpeaking(true);

    // 1️⃣ Solicita audio generado con Polly
    const res = await axios.post(
      'https://profevoz.asistentevirutalia.com/api/tts',
      { text, lang: outputLangRef.current },
      { responseType: 'blob' }
    );

    // 2️⃣ Crea objeto URL para reproducir el audio
    const url = URL.createObjectURL(res.data);
    const audio = new Audio(url);
    currentAudioRef.current = audio;

    // 3️⃣ Inicia reproducción
    console.log("🔊 Reproduciendo audio...");
    audio.play();

    // 4️⃣ Al terminar, limpiar y reactivar micrófono
    audio.onended = () => {
      console.log("✅ Reproducción finalizada.");
      currentAudioRef.current = null;
      setAssistantSpeaking(false);
      URL.revokeObjectURL(url); // Limpieza

      if (!text.toLowerCase().includes("adiós")) {
        handleListen(); // Reactiva el micrófono automáticamente
      } else {
        console.log("🛑 Fin de conversación detectado.");
      }
    };
  } catch (err) {
    console.error('❌ Error reproduciendo audio:', err);
    setAssistantSpeaking(false);
  }
};



/**
 * Inicia el stream de respuesta del Assistant vía SSE.
 * Recibe el threadId activo y el mensaje del usuario.
 * Muestra la respuesta progresiva en el chat y reproduce la voz al finalizar.
 */
const startStreamingAssistant = (threadId, message) => {
  if (!message) return;

  const url = `https://profevoz.asistentevirutalia.com/api/assistant-stream?thread_id=${threadId}&message=${encodeURIComponent(message)}`;
  const eventSource = new EventSource(url);

  let fullText = '';
  let speakTimeout = null;
  let spoken = false;

  // 1️⃣ Mostrar de inmediato "💬 Contestando..." en el historial
  setChatHistory(prev => [
    ...prev,
    { role: 'assistant', text: '💬 Contestando...' }
  ]);

  // 2️⃣ Maneja cada chunk recibido del Assistant
  eventSource.onmessage = (e) => {
    fullText += e.data;

    // Actualiza el último mensaje del Assistant en el historial con el texto parcial
    setChatHistory(prev => {
      const updated = [...prev];
      const lastIndex = updated.map(m => m.role).lastIndexOf('assistant');
      if (lastIndex !== -1) {
        updated[lastIndex].text = fullText;
      }
      return updated;
    });

    // Reinicia el temporizador para hablar (solo si no ha hablado)
    clearTimeout(speakTimeout);
    speakTimeout = setTimeout(() => {
      if (!spoken && fullText.length > 0) {
        speakText(fullText); // Llama a Polly y reproduce el audio
        spoken = true;
      }
    }, 1000);
  };

  // 3️⃣ Maneja el evento personalizado "done" enviado desde el backend
  eventSource.addEventListener('done', () => {
    if (!spoken && fullText.length > 0) {
      speakText(fullText);
      spoken = true;
    }
    eventSource.close();
    console.log("✅ SSE cerrado: evento 'done'");
  });

  // 4️⃣ En caso de error en la conexión o finalización abrupta
  eventSource.onerror = (e) => {
    console.warn('⚠️ SSE error o cerrado inesperadamente:', e);
    eventSource.close();

    // Como respaldo, reproduce el audio si aún no se hizo
    if (!spoken && fullText.length > 0) {
      speakText(fullText);
      spoken = true;
    }
  };
};



  const startTranscribeStream = async () => {
    if (!navigator.mediaDevices) {
      alert("No se puede acceder al micrófono");
      return;
    }

    setIsListening(true);

    const langToUse = inputLangRef.current || 'es-US';
    console.log("🌐 Abriendo Transcribe con idioma:", langToUse);
    wsRef.current = new WebSocket(`wss://profevoz.asistentevirutalia.com/transcribe/?lang=${langToUse}`);


    
 wsRef.current.onopen = async () => {
  try {
    // ✅ Reiniciar referencias de control de audio
    silentFrameCountRef.current = 0;
    frameSkipCountRef.current = 0;
    hasDetectedSpeechRef.current = false;

    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 44100 });
    mediaStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });

    const source = audioContextRef.current.createMediaStreamSource(mediaStreamRef.current);
    const processor = audioContextRef.current.createScriptProcessor(4096, 1, 1);

    source.connect(processor);
    processor.connect(audioContextRef.current.destination);

    processor.onaudioprocess = (e) => {
      const input = e.inputBuffer.getChannelData(0);
      const pcm = convertFloat32ToInt16(input);

      const rms = calculateRMS(input);
      setMicVolume(rms);

      const WARMUP_FRAMES = 5;               // Ignora primeros 15 frames (~1.5s)
      const SILENT_FRAMES_THRESHOLD = 25;     // Requiere 40 frames de silencio (~4s)
      const MIN_RMS_TO_DETECT_SPEECH = 0.005; // Umbral para decir que ya está hablando

      frameSkipCountRef.current++;

      // No enviar audio ni evaluar silencio hasta completar warmup
      if (frameSkipCountRef.current <= WARMUP_FRAMES) return;

      if (wsRef.current?.readyState === WebSocket.OPEN) {
        wsRef.current.send(pcm);
      }

      if (rms > MIN_RMS_TO_DETECT_SPEECH) {
        hasDetectedSpeechRef.current = true;
      }

      if (!hasDetectedSpeechRef.current) return;

      if (rms < SILENCE_THRESHOLD) {
        silentFrameCountRef.current += 1;

        if (silentFrameCountRef.current > SILENT_FRAMES_THRESHOLD) {
          console.log("🤫 Silencio prolongado tras hablar, cerrando WebSocket.");
          wsRef.current?.close();
        }
      } else {
        silentFrameCountRef.current = 0;
      }
    };

    processorRef.current = processor;
  } catch (err) {
    console.error("❌ Error accediendo al micrófono:", err);
    stopAudioCapture();
  }
};




wsRef.current.onmessage = async (msg) => {
  try {
    const data = JSON.parse(msg.data);
    if (data.transcript) {
      wsRef.current?.close();
      stopAudioCapture();

      const userMessage = data.transcript.trim();
      setTranscript(userMessage);

      // ✅ Mostrar inmediatamente el mensaje del usuario
      setChatHistory(prev => [...prev, { role: 'user', text: userMessage }]);

      let threadId = threadIdRef.current;
      if (!threadId) {
        threadId = await fetchThreadId();
      }

      if (threadId) {
        startStreamingAssistant(threadId, userMessage);
      }
    }
  } catch (err) {
    console.error("⚠️ Error procesando mensaje:", err);
  }
};


    wsRef.current.onerror = (e) => {
      console.error("❌ WebSocket error:", e);
      stopAudioCapture();
      setIsListening(false);
    };

    wsRef.current.onclose = () => {
      stopAudioCapture();
    };
  };

  const convertFloat32ToInt16 = (buffer) => {
    const buf = new Int16Array(buffer.length);
    for (let i = 0; i < buffer.length; i++) {
      const s = Math.max(-1, Math.min(1, buffer[i]));
      buf[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
    return buf.buffer;
  };

  const calculateRMS = (samples) => {
    let sum = 0;
    for (let i = 0; i < samples.length; i++) {
      sum += samples[i] * samples[i];
    }
    return Math.sqrt(sum / samples.length);
  };

  const sendToAssistant = async (text) => {
    setIsLoading(true);
    try {
      const res = await axios.post('https://profevoz.asistentevirutalia.com/api/ask', {
        message: text,
        user: 'paulo_cardenas@yahoo.com'
      });
      setChatHistory(prev => [...prev, { role: 'user', text }, { role: 'assistant', text: res.data.text }]);
      const audio = new Audio("data:audio/mp3;base64," + res.data.audio);
      currentAudioRef.current = audio;
      setAssistantSpeaking(true);
      audio.play();
      audio.onended = () => {
        currentAudioRef.current = null;
        setAssistantSpeaking(false);
        if (!res.data.text.toLowerCase().includes("adiós")) {
          handleListen();
        } else {
          console.log("🛑 Fin de conversación");
        }
      };
    } catch (err) {
      console.error('❌ Error enviando al asistente:', err);
      setAssistantSpeaking(false);
    } finally {
      setIsLoading(false);
    }
  };

const handleNewConversation = async () => {
  try {
    // Vaciar historial visual
    setChatHistory([]);
    setTranscript('');
    setResponseText('');

    // Obtener nuevo thread desde el backend
    const res = await axios.post('https://profevoz.asistentevirutalia.com/api/threads');
    const newThreadId = res.data.thread_id;

    // Guardarlo en localStorage y referencia actual
    localStorage.setItem('thread_id', newThreadId);
    threadIdRef.current = newThreadId;

    console.log('🆕 Nueva conversación iniciada con thread_id:', newThreadId);
  } catch (err) {
    console.error('❌ Error creando nuevo thread:', err);
  }
};





return (
  <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
    <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>
      🎙 Asistente Virtual por Voz
    </h2>


<button
  onClick={handleNewConversation}
  style={{
    padding: '0.5rem 1rem',
    fontSize: '1rem',
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginBottom: '1rem',
    alignSelf: 'flex-start'
  }}
>
  🆕 Nueva conversación
</button>







    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.5rem' }}>
      {/* Switch Entrada */}
      <LanguageSwitch
        label="Idioma de entrada:"
        lang={inputLang}
        onToggle={() => setInputLang(inputLang === 'en-US' ? 'es-US' : 'en-US')}
      />

      {/* Switch Salida */}
      <LanguageSwitch
        label="Idioma de respuesta:"
        lang={outputLang}
        onToggle={() => setOutputLang(outputLang === 'en-US' ? 'es-US' : 'en-US')}
      />

      {/* Checkbox Transcribe */}
      <div>
        <label>
          <input
            type="checkbox"
            checked={useTranscribe}
            onChange={() => setUseTranscribe(!useTranscribe)}
          />{" "}
          Usar Amazon Transcribe
        </label>
      </div>
    </div>

    {/* Chat history con globos */}
    <div
      id="chat-history"
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '300px',
        overflowY: 'auto',
        marginBottom: '1rem',
        border: '1px solid #ccc',
        borderRadius: '8px',
        padding: '1rem',
        background: '#fff'
      }}
    >
      {chatHistory.map((item, index) => (
        <ChatBubble key={index} text={item.text} isUser={item.role === 'user'} />
      ))}
    </div>

    <button
      onClick={assistantSpeaking ? interruptAssistant : handleListen}
      disabled={isListening || isLoading}
      style={{
        padding: '1rem 2rem',
        fontSize: '1.25rem',
        backgroundColor: assistantSpeaking ? '#ff4d4f' : '#4CAF50',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        marginBottom: '1rem',
      }}
    >
      {assistantSpeaking ? 'Interrumpir' : isListening ? 'Escuchando...' : 'Hablar'}
    </button>

    {isListening && (
      <TranscribeBar volume={micVolume} threshold={SILENCE_THRESHOLD} />
    )}
  </div>
);

};

export default VoiceAssistant;
